import React, { useCallback, useContext, useEffect, useState } from 'react';
import { Button } from '@vodafoneis/sjonvarpskjarni-js-lib';
import styled from 'styled-components';
import { CHROMECAST_EVENTS } from '../../../../models/THEOPlayer';
import { PlaybackInformationContext } from '../../../../contexts/PlaybackInformationContext';
import { CastState } from '../../../../models/CastState';
import airplayIcon from '../../../../../public/images/airplay.png';

const { STATE_CHANGE } = CHROMECAST_EVENTS;
const { UNAVAILABLE } = CastState;

const PlaybackSettingsAirplayButton = styled(Button)`
	width: 20px;
	height: 20px;
	background: url(${airplayIcon.src}) no-repeat;
	background-size: 100% 100%;
`;

export const PlaybackSettingsAirplay: React.FC = () => {
	const { player } = useContext(PlaybackInformationContext);

	const [airplayState, setAirplayState] = useState(player?.getAirplayState());

	useEffect(() => {
		setAirplayState(player?.getAirplayState());

		const onAirplayStateChanged = ({ state }) => {
			setAirplayState(state);
		};

		player.addAirplayListener(STATE_CHANGE, onAirplayStateChanged);

		return () => {
			if (player) {
				player.removeAirplayListener(STATE_CHANGE, onAirplayStateChanged);
			}
		};
	}, [player]);

	const onAirplayButtonPressed = useCallback(
		(event) => {
			event.preventDefault();
			event.stopPropagation();

			if (!player.isAirplaying()) {
				player.startAirplay();
			} else {
				player.stopAirplay();
			}
		},
		[player]
	);

	if (!airplayState || airplayState === UNAVAILABLE) return null;

	return <PlaybackSettingsAirplayButton onClick={onAirplayButtonPressed} />;
};
